<div class="web-based-service">
  <div class="web-based-service__content">
    <p *ngIf="title" class="web-based-service__content__title">{{ title }}</p>
    <h3 class="web-based-service__content__header">{{ header }}</h3>
    <p class="web-based-service__content__description" [innerHTML]="description"></p>
    <!-- <ng-content select="[sm-webbased-button]"></ng-content> -->
  </div>
</div>
